import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const processCompanyNameColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'company',
  label: <Trans i18nKey="company" />,
  render: (value) => {
    return <div className="overflow-hidden text-ellipsis">{value}</div>;
  },
  sortable: true,
  acessorKey: 'company',
  align: 'left',
  alignHeader: 'left',
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
